import casual from 'casual-browserify';
import {ApolloError} from 'apollo-client';
import {GraphQLError} from 'graphql';

// resource -> mocking with casual http://bit.ly/2pOYqXF
// seed out data so our randomly generated values are repeatable for testing
casual.seed( 999 );

export {casual};

casual.define( 'productName', () => (
    casual.random_element( [
        'Triodent® V3 Ring',
        'Triodent® V-Wedge',
        'Peak™ Universal Bond',
        'Peak™-ZM',
        'Enamelast™',
        'VALO™',
        '​Opalescence™ Boost™',
        'Consepsis Scrub',
        'UltraSeal XT plus',
        'PermaFlo Purple',
        'PermaFlo Pink',
        'ChlorCid',
        'Anatomical Matrix',
        'Jiffy Composite Polishing Brush',
        'Sable Seek',
        'Ultra-Blend plus',
        'UltraPro Tx',
        'PermaFlo DC-Media',
        'PermaSeal-Media',
        'Opalescence-Media',
        'Gishy Goo',
        'Gemini',
        'PermaFlo Pink-Media',
        'Opal Seal'
    ] )
) );

casual.define( 'kitName', () => (
    casual.random_element( [
        'Triodent® V3 Ring Sectional Matrix Ring',
        'Triodent® V-Wedge Disposable Anatomical Wedge',
        'Peak™ Universal Bond Light-Cured Adhesive with Chlorhexidine (0.2%)',
        'Peak™-ZM Zirconia and Metal Primer',
        'Enamelast™ Fluoride Varnish',
        'VALO™ Curing Light Accessories',
        '​Opalescence™ Boost™ In-Office Power Whitener'
    ] )
) );

casual.define( 'productSku', () => (
    casual.random_element( [
        casual.numerify( '####-' ),
        casual.numerify( '####-US' ),
        casual.numerify( '####-I' )
    ] ))
);

casual.define( 'serialNumber', () => casual.random_element( [
    casual.numerify( 'CB####-A#/00##' ),
    casual.numerify( 'CB####-A###' ),
    casual.numerify( 'CB####-###' ),
    casual.numerify( 'CB#####' )
] ) );
casual.define( 'lotNumber', () => casual.numerify( 'L#####' ) );

casual.define( 'randomRecentDate', () => (
    casual.random_element( [
        '01-01-2018',
        '01-10-2018',
        '04-12-2018',
        '01-05-2018',
        '03-04-2018',
        '01-21-2018',
        '02-16-2018',
        '02-27-2018'] )
) );

casual.define( 'upsTrackingNumber', () => casual.numerify( '1Z##MOCK############' ) );

// canned placeIds for mapping across models
casual.define( 'placeId', () => (
    // casual.random_element( ['112233', '987789', '565656', '465746', '345321', '223441'] )
    '112233'
) );

casual.define( 'rowId', ( prefix = '' ) => () => casual.numerify( `${prefix}######` ) );

casual.define( 'money', ( min = 99, max = 199 ) => () => casual.double( min, max ).toFixed( 2 ) );
casual.define( 'optionId', () => casual.integer( 0, 999 ) );
casual.define( 'quantity', () => casual.integer( 1, 12 ) );
casual.define( 'array_of', ( n, type ) => {
    let col = [];
    while ( n > 0 ) {
        col.push( typeof type === 'function' ? type() : type );
        n--;
    }

    return col;
} );

export const Date = () => casual.date();
export const DateTime = () => casual.date();
export const Decimal = () => casual.double( 0, 199 );
export const Address = ( overrides = {} ) => ({
    id: Math.floor( Math.random() * 10000 ),
    placeId: casual.placeId,
    address1: casual.address1,
    address2: casual.address2,
    addressType: casual.random_element( ['Billing', 'Shipping'] ),
    city: casual.city,
    state: casual.state_abbr,
    country: 'US',
    primary: casual.boolean,
    postalCode: casual.zip( 5 ),
    ...overrides,
    __typename: 'Address'
});

export const FileAsset = overrides => ({
    description: casual.description,
    source: casual.random_element( [
        'https://images.ctfassets.net/0ra6eigm70if/b74bc761226a6235926708340c05479e/5710b7e2ade986dcd69a16c931652734/Opalescence-Go-Mint-and-Melon-Patient-and-Mini-Kits-category-group_WHITEN.jpg',
        'https://images.ctfassets.net/0ra6eigm70if/1ea78b6531d8ddfbc6326cf2cf6d7f3d/fbf412b16ba24092f237b0c4129d00da/Omni-Matrix-Wingless-0.001-Orange_PREPARE.jpg',
        'https://images.ctfassets.net/0ra6eigm70if/BRAND_581/38b7e217d6a5207b7314b1b3abfab128/Peak-Universal-Bond-syringe-and-bottle_BOND-ETCH.jpg',
        'https://images.ctfassets.net/0ra6eigm70if/BRAND_1161/38ae6434c2a98e25f2e2b9ff7386d4c9/PermaQuick-syringes-with-tip_BOND-ETCH.jpg',
        'https://images.ctfassets.net/0ra6eigm70if/BRAND_1562/7dd0e73f42c175d8e94f788f8ac9f3be/Black-Micro-FX-Tip_TIPS.jpg',
        'https://images.ctfassets.net/0ra6eigm70if/d6dae1fe7f2b634575263f0cedcbe79e/057aeeca95ff1d61fe76ad8f590815d1/403316_V3-SuperCurve-Kit-open_PREPARE.jpg',
        'https://images.ctfassets.net/0ra6eigm70if/BRAND_881/20a4cf81aa692a156250af3f7a68c152/Astringedent-X-group_TM.jpg'
    ] ),
    ...overrides,
    __typename: 'FileAsset'
});

export const mockError = err => ( root, {input}, context ) => {
    const message = err.message ||
        '!@ A mock error message was not provided. Verify your mock call provides a "message" argument';
    const extensions = err.extensions;

    console.warn( `[MOCK ${Object.keys( root )[0] || 'unknownQuery'} ERROR]` );

    /**
     * Function signature
     message: string,
     nodes?: $ReadOnlyArray<ASTNode> | ASTNode | void,
     source?: ?Source,
     positions?: ?$ReadOnlyArray<number>,
     path?: ?$ReadOnlyArray<string | number>,
     originalError?: ?Error & { +extensions: mixed, ... },
     extensions?: ?{ [key: string]: mixed, ... }
     */
    throw new GraphQLError( message, null, null, null, null, null, extensions );
};

/*


casual DOCS

Define custom generators
casual.define('user', function() {
	return {
		email: casual.email,
		firstname: casual.first_name,
		lastname: casual.last_name,
		password: casual.password
	};
});

// Generate object with randomly generated fields
var user = casual.user;
If you want to pass some params to your generator:

casual.define('profile', function(type) {
	return {
		title: casual.title,
		description: casual.description,
		type: type || 'private'
	};
});

// Generate object with random data
var profile = casual.profile('public');


https://github.com/boo1ean/casual#embedded-generators
// Address

casual.country              // 'United Kingdom'
casual.city                 // 'New Ortiz chester'
casual.zip(digits = {5, 9}) // '26995-7979' (if no digits specified then random selection between ZIP and ZIP+4)
casual.street               // 'Jadyn Islands'
casual.address              // '6390 Tremblay Pines Suite 784'
casual.address1             // '8417 Veda Circles'
casual.address2             // 'Suite 648'
casual.state                // 'Michigan'
casual.state_abbr           // 'CO'
casual.latitude             // 90.0610
casual.longitude            // 180.0778
casual.building_number      // 2413

// Text

casual.sentence               // 'Laborum eius porro consequatur.'
casual.sentences(n = 3)       // 'Dolorum fuga nobis sit natus consequatur. Laboriosam sapiente. Natus quos ut.'
casual.title                  // 'Systematic nobis'
casual.text                   // 'Nemo tempore natus non accusamus eos placeat nesciunt. et fugit ut odio nisi dolore non ... (long text)'
casual.description            // 'Vel et rerum nostrum quia. Dolorum fuga nobis sit natus consequatur.'
casual.short_description      // 'Qui iste similique iusto.'
casual.string                 // 'saepe quia molestias voluptates et'
casual.word                   // 'voluptatem'
casual.words(n = 7)           // 'sed quis ut beatae id adipisci aut'
casual.array_of_words(n = 7)  // [ 'voluptas', 'atque', 'vitae', 'vel', 'dolor', 'saepe', 'ut' ]
casual.letter                 // 'k'

// Internet

casual.ip           // '21.44.122.149'
casual.domain       // 'darrion.us'
casual.url          // 'germaine.net'
casual.email        // 'Josue.Hessel@claire.us'
casual.user_agent   // 'Mozilla/5.0 (Windows NT 6.1; WOW64; rv:34.0) Gecko/20100101 Firefox/34.0'

// Person

casual.name            // 'Alberto'
casual.username        // 'Darryl'
casual.first_name      // 'Derek'
casual.last_name       // 'Considine'
casual.full_name       // 'Kadin Torphy'
casual.password        // '(205)580-1350Schumm'
casual.name_prefix     // 'Miss'
casual.name_suffix     // 'Jr.'
casual.company_name    // 'Cole, Wuckert and Strosin'
casual.company_suffix  // 'Inc'
casual.catch_phrase    // 'Synchronised optimal concept'
casual.phone           // '982-790-2592'

// Numbers

casual.random                            // 0.7171590146608651 (core generator)
casual.integer(from = -1000, to = 1000)  // 632
casual.double(from = -1000, to = 1000)   // -234.12987444
casual.array_of_digits(n = 7)            // [ 4, 8, 3, 1, 7, 6, 6 ]
casual.array_of_integers(n = 7)          // [ -105, -7, -532, -596, -430, -957, -234 ]
casual.array_of_doubles(n = 7)           // [ -866.3755785673857, -166.62194719538093, ...]
casual.coin_flip                         // true

// Date

casual.unix_time                    // 659897901
casual.moment                       // moment.js object see http://momentjs.com/docs/
casual.date(format = 'YYYY-MM-DD')  // '2001-07-06' (see available formatters http://momentjs.com/docs/#/parsing/string-format/)
casual.time(format = 'HH:mm:ss')    // '03:08:02' (see available formatters http://momentjs.com/docs/#/parsing/string-format/)
casual.century                      // 'IV'
casual.am_pm                        // 'am'
casual.day_of_year                  // 323
casual.day_of_month                 // 9
casual.day_of_week                  // 4
casual.month_number                 // 9
casual.month_name                   // 'March'
casual.year                         // 1990
casual.timezone                     // 'America/Miquelon'

// Payments

casual.card_type            // 'American Express'
casual.card_number(vendor)  // '4716506247152101' (if no vendor specified then random)
casual.card_exp             // '03/04'
casual.card_data            // { type: 'MasterCard', number: '5307558778577046', exp: '04/88', holder_name: 'Jaron Gibson' }

// Misc

casual.country_code    // 'ES'
casual.language_code   // 'ru'
casual.locale          // 'hi_IN'
casual.currency        // { symbol: 'R', name: 'South African Rand', symbol_native: 'R', decimal_digits: 2, rounding: 0, code: 'ZAR', name_plural: 'South African rand' }
casual.currency_code   // 'TRY'
casual.currency_symbol // 'TL'
casual.currency_name   // Turkish Lira
casual.mime_type       // 'audio/mpeg'
casual.file_extension  // 'rtf'
casual.boolean         // true
casual.uuid            // '2f4dc6ba-bd25-4e66-b369-43a13e0cf150'

// Colors

casual.color_name       // 'DarkOliveGreen'
casual.safe_color_name  // 'maroon'
casual.rgb_hex          // '#2e4e1f'
casual.rgb_array        // [ 194, 193, 166 ]

*/